import { Hexagon } from 'react-hexgrid';
import styled from '@emotion/styled';

export const WrapperMobile = styled.div`
  width: 100%;  
  display: none;
  position: relative;

  svg {
    position: absolute;
    top: 0;
    left: 0;
  }

  @media (max-width: 780px) {
    display: block;
  }
`;

export const WrapperDesktop = styled.div`
  width: 100%;
  max-width: 600px;  
  display: block;
  position: relative;
  margin: auto;

  svg {
    position: absolute;
    top: 0;
    left: 0;
  }

  @media (max-width: 780px) {
    display: none;
  }
`;

export const Canvas = styled.canvas`
  width: 100%;
  height: 100%;
  display: block;
  visibility: hidden;
`;

export const Hex = styled(Hexagon)`
  fill-opacity: 1;

  & polygon {
    transition: all 200ms;
    stroke: ${({ theme }) => theme.colors.postnav.outline};
    stroke-width: 0.3;
    fill: ${({ theme }) => theme.colors.postnav.backgroundAlternative};
    cursor: pointer;
  }

  & text {
    font-size: 0.1425em;
    fill: ${({ theme }) => theme.colors.postnav.linkAlternative};
    fill-opacity: 1;
    stroke-width: 0.5;
  }

  &:hover polygon {
    stroke: ${({ theme }) => theme.colors.postnav.outlineActive};
    stroke-opacity: 0.8;
    stroke-width: 0.5;
    fill: ${({ theme }) => theme.colors.postnav.backgroundActive};
  }

  &:hover text {
    fill: ${({ theme }) => theme.colors.postnav.linkActive};
    fill-opacity: 0.8;
  }
`;